<div class="modal" [class.hidden]="!isOpen" (click)="closeOnBackdropClick($event)">
  <div [class.modal-top]="longModal" [class.modal-fixed-height]="fixedHeight" class="modal-content">
    <div class="modal-header" [class.modal-header-line]="title != ''">
      <button *ngIf="showCloseButton" class="close-btn" (click)="requestClose()">
        <span class="material-icons">close</span>
      </button>
      <span class="modal-title">{{title}}</span>
    </div>
    <div class="modal-body">
      <ng-content></ng-content>
    </div>
    <div class="modal-footer" *ngIf="confirmationModal">
      <div class="footer-btn-container">
        <button class="footer-button" type="button" (click)="noClicked()"
        [style.color]="negativeColor" [style.backgroundColor]="negativeBgColor">{{negativeText}}</button>
        <button class="footer-button" type="button" (click)="yesClicked()"
        [style.color]="positiveColor" [style.backgroundColor]="positiveBgColor">{{positiveText}}</button>
      </div>
    </div>

    <div class="modal-footer" *ngIf="okModal">
      <div class="footer-btn-container">
      <button class="footer-button blue-button" type="button" (click)="requestClose()">{{getString('ok')}}</button>
      </div>
    </div>

    <div class="close-confirmation-backdrop" *ngIf="showCloseConfirmation">
      <div class="close-confirmation-modal">
        <div class="close-confirmation-title">{{getCloseConfirmationTitle()}}</div>
        <div class="close-confirmation-text">{{getCloseConfirmationText()}}</div>
        <div class="footer-btn-container">
          <button class="footer-button" type="button" (click)="cancelCloseClicked()"
          [style.color]="negativeColor" [style.backgroundColor]="negativeBgColor">{{getCloseConfirmationNegativeText()}}</button>
          <button class="footer-button" type="button" (click)="confirmCloseClicked()"
          [style.color]="positiveColor" [style.backgroundColor]="positiveBgColor">{{getCloseConfirmationPositiveText()}}</button>
        </div>
      </div>
    </div>

  </div>
</div>
